module.exports = __webpack_public_path__ + "static/media/S1N9-5.17e84bb3.svg";